"use strict";import{IconAddCircle as e}from"../src/elements/IconAddCircle.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-add-circle",e);
//# sourceMappingURL=sp-icon-add-circle.js.map
